"use client";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { useSystem } from "@/lib/store/system-store/store";
import { NetworkStatusCodes } from "@/lib/utils/error-definitions";

import React from "react";
import LoginCard from "../card/c-login-card";

const ErrorModal = () => {
  const { errors, removeError } = useSystem();

  return (
    <>
      {errors?.map((error, index) => (
        <Dialog key={index} open={errors[index] === error}>
          <DialogContent
            className={`max-w-[30rem] flex flex-col gap-y-3 transition-all `}
          >
            {error.networkStatusCode === NetworkStatusCodes.UNAUTHORIZED ? (
              <>
                <DialogTitle>Login to continue</DialogTitle>
                <div className=" gap-4 flex flex-col h-[25rem]">

                <LoginCard />
                </div>
              </>
            ) : (
              <>
                <DialogTitle className="flex justify-between items-center">
                  <p>Something went wrong!</p>
                  <div className=" flex gap-2">
                    <Badge variant="destructive_secondary">
                      {error.clientStatusCode || error.networkStatusCode}
                    </Badge>

                    <Badge variant="destructive_secondary">{error.type}</Badge>
                  </div>
                </DialogTitle>

                <DialogDescription className=" rounded-base p-2">
                  {error.message}
                </DialogDescription>

                <div className="flex flex-1 items-end justify-end">
                  <Button
                    onClick={() => removeError(index)}
                    size={"base"}
                    variant="destructive"
                  >
                    Dismiss
                  </Button>
                </div>
              </>
            )}
          </DialogContent>
        </Dialog>
      ))}
    </>
  );
};

export default ErrorModal;
